import { createReducer, on } from '@ngrx/store';

import { IContact } from '@ruby/modules/account/models/contact.interface';
import { IThirdPartyLOA, IThirdPartyLOAStatus, IThirdPartyTemplate } from '@ruby/modules/third-party/models/third-party.interface';
import * as ThirdPartyCoreActions from '@ruby/modules/third-party/store/actions/third-party-core.actions';
import { IError } from '@ruby/shared/models/request/error.interface';

export const featureKey = 'core';

export interface State {
  loading: boolean;
  loadingContract: boolean;
  loadingStatus: boolean;
  loadingContact: boolean;
  loadingUpdateStatus: boolean;
  loadingTemplate: boolean;
  loadingCreation: boolean;
  loadingUpdateLOA: boolean;
  loas: Array<IThirdPartyLOA>;
  loa?: IThirdPartyLOA;
  status?: IThirdPartyLOAStatus;
  contact?: IContact;
  updatedLoa?: IThirdPartyLOA;
  contractTemplate?: IThirdPartyTemplate;
  error?: IError;
}

export const initialState: State = {
  loading: false,
  loadingContract: false,
  loadingStatus: false,
  loadingContact: false,
  loadingUpdateStatus: false,
  loadingTemplate: false,
  loadingCreation: false,
  loadingUpdateLOA: false,
  loas: [],
  status: undefined,
  loa: undefined,
  contact: undefined,
  updatedLoa: undefined,
  contractTemplate: undefined,
  error: undefined
};

export const reducer = createReducer(
  initialState,
  on(ThirdPartyCoreActions.loadLOA, (state, action) => ({
    ...state,
    loading: true,
    error: undefined
  })),
  on(ThirdPartyCoreActions.loadLOASuccess, (state, action) => ({
    ...state,
    loading: false,
    loas: action.data
  })),
  on(ThirdPartyCoreActions.loadLOAFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error
  })),
  on(ThirdPartyCoreActions.loadContract, (state, action) => ({
    ...state,
    loadingContract: true,
    loa: undefined,
    error: undefined
  })),
  on(ThirdPartyCoreActions.loadContractSuccess, (state, action) => ({
    ...state,
    loadingContract: false,
    loa: action.data
  })),
  on(ThirdPartyCoreActions.loadContractFailure, (state, action) => ({
    ...state,
    loadingContract: false,
    error: action.error
  })),
  on(ThirdPartyCoreActions.loadLOAStatus, (state, action) => ({
    ...state,
    loadingStatus: true,
    status: undefined,
    error: undefined
  })),
  on(ThirdPartyCoreActions.loadLOAStatusSuccess, (state, action) => ({
    ...state,
    loadingStatus: false,
    status: action.data
  })),
  on(ThirdPartyCoreActions.loadLOAStatusFailure, (state, action) => ({
    ...state,
    loadingStatus: false,
    error: action.error
  })),
  on(ThirdPartyCoreActions.loadContactDetails, (state, action) => ({
    ...state,
    loadingContact: true,
    contact: undefined,
    error: undefined
  })),
  on(ThirdPartyCoreActions.loadContactDetailsSuccess, (state, action) => ({
    ...state,
    loadingContact: false,
    contact: action.data
  })),
  on(ThirdPartyCoreActions.loadContactDetailsFailure, (state, action) => ({
    ...state,
    loadingContact: false,
    error: action.error
  })),
  on(ThirdPartyCoreActions.updateLOAStatus, (state, action) => ({
    ...state,
    loadingUpdateStatus: true,
    updatedLoa: undefined,
    error: undefined
  })),
  on(ThirdPartyCoreActions.updateLOAStatusSuccess, (state, action) => ({
    ...state,
    loadingUpdateStatus: false,
    updatedLoa: action.data
  })),
  on(ThirdPartyCoreActions.updateLOAStatusFailure, (state, action) => ({
    ...state,
    loadingUpdateStatus: false,
    error: action.error
  })),
  on(ThirdPartyCoreActions.loadTemplate, (state, action) => ({
    ...state,
    loadingTemplate: true,
    contractTemplate: undefined,
    error: undefined
  })),
  on(ThirdPartyCoreActions.loadTemplateSuccess, (state, action) => ({
    ...state,
    loadingTemplate: false,
    contractTemplate: action.data
  })),
  on(ThirdPartyCoreActions.loadTemplateFailure, (state, action) => ({
    ...state,
    loadingTemplate: false,
    contractTemplate: undefined,
    error: action.error
  })),
  on(ThirdPartyCoreActions.signLOA, (state, action) => ({
    ...state,
    loadingCreation: true
  })),
  on(ThirdPartyCoreActions.signLOASuccess, (state, action) => ({
    ...state,
    loadingCreation: false,
    loa: action.data
  })),
  on(ThirdPartyCoreActions.signLOAFailure, (state, action) => ({
    ...state,
    loadingCreation: false,
    error: action.error
  })),
  on(ThirdPartyCoreActions.hardReset, (state, action) => ({
    ...state,
    loa: undefined
  })),
  on(ThirdPartyCoreActions.updateLOA, (state, action) => ({
    ...state,
    loadingUpdateLOA: true,
    error: undefined
  })),
  on(ThirdPartyCoreActions.updateLOASuccess, (state, action) => ({
    ...state,
    loadingUpdateLOA: false,
    loa: undefined
  })),
  on(ThirdPartyCoreActions.updateLOAFailure, (state, action) => ({
    ...state,
    loadingUpdateLOA: false,
    error: action.error
  }))
);
